<template>
  <div class="part">
    <part-title v-if="title">
      {{ title }}
    </part-title>

    <slot></slot>
  </div>
</template>

<script>
import partTitle from '@/components/frontoffice/partTitle'

export default {
  components: {
    partTitle
  },
  props: {
    title: String
  }
}
</script>
